import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormCheckbox } from '@ui/forms/Checkbox'
import InputsSection from '@ui/forms/InputsSection'
import FormSection, { FormRow } from './FormSection'
import { CofidisMonthlyApplicationFormValues } from '../types'
import { useEffect } from 'react'

export default function TermsSection() {
  const { t } = useTranslation(['cofidis'])
  const { control, trigger } =
    useFormContext<CofidisMonthlyApplicationFormValues>()

  const [vedaconAcceptance, internalOptin, partnerOptin] = useWatch({
    control,
    name: ['vedaconAcceptance', 'internalOptin', 'partnerOptin'],
  })

  useEffect(() => {
    if (vedaconAcceptance === undefined) return
    trigger('vedaconAcceptance')
  }, [trigger, vedaconAcceptance])

  useEffect(() => {
    if (internalOptin === undefined) return
    trigger('internalOptin')
  }, [trigger, internalOptin])

  useEffect(() => {
    if (partnerOptin === undefined) return
    trigger('partnerOptin')
  }, [trigger, partnerOptin])

  return (
    <InputsSection group>
      <FormSection>
        <FormRow>
          <FormCheckbox
            required
            control={control}
            name="vedaconAcceptance"
            label={t('cofidis:vedaconAcceptance.label')}
            desc={t('cofidis:vedaconAcceptance.desc')}
          />
        </FormRow>
        <FormRow>
          <FormCheckbox
            required
            control={control}
            name="internalOptin"
            label={t('cofidis:internalOptin.label')}
            desc={t('cofidis:internalOptin.desc')}
          />
        </FormRow>
        <FormRow>
          <FormCheckbox
            required
            control={control}
            name="partnerOptin"
            label={t('cofidis:partnerOptin.label')}
            desc={t('cofidis:partnerOptin.desc')}
          />
        </FormRow>
      </FormSection>
    </InputsSection>
  )
}
